import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { PrismBadge, PrismIconBrand } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import type { IconBrandName } from '@mylighthouse/prism-ember/types/components/prism/icon-brand';
import type { Ota } from 'frontend-utils/models';

const MAX_OTAS_TO_SHOW = 5;

function sort(otas: Ota[] | undefined = []): Ota[] {
  return [...otas].sort((a, b) => {
    return a.order - b.order;
  });
}

interface GeneralListsContentCategoryOtasSignature {
  Args: {
    otas?: Ota[];
  };
}

export default class GeneralListsContentCategoryOtas extends Component<GeneralListsContentCategoryOtasSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  @cached get otas() {
    const otas = sort(this.args.otas);

    return otas.map((ota) => {
      const { id, name } = ota;

      return {
        icon: id! as IconBrandName,
        name,
      };
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get otasToDisplay() {
    const endIndex = this.truncate ? MAX_OTAS_TO_SHOW - 1 : this.otas.length;

    return this.otas.slice(0, endIndex);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get otasToHide() {
    return this.otas.slice(MAX_OTAS_TO_SHOW - 1);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get truncate() {
    return this.otas.length > MAX_OTAS_TO_SHOW;
  }

  <template>
    {{! template-lint-disable table-groups }}
    <div class="flex items-center gap-100 pr-100 pl-100">
      {{#each this.otasToDisplay as |ota|}}
        <div>
          <PrismIconBrand @name={{ota.icon}} />
          <EmberTooltip @tooltipClass="default-tooltip">
            <div class="flex items-center gap-100">
              <PrismIconBrand @name={{ota.icon}} />
              {{ota.name}}
            </div>
          </EmberTooltip>
        </div>
      {{/each}}

      {{#if this.truncate}}
        <div>
          <PrismBadge @label="+{{this.otasToHide.length}}" />
          <EmberTooltip @tooltipClass="default-tooltip default-table-tooltip">
            <table class="default-table">
              {{#each this.otasToHide as |ota|}}
                <tr>
                  <td>
                    <div class="flex items-center gap-100">
                      <PrismIconBrand @name={{ota.icon}} />
                      {{ota.name}}
                    </div>
                  </td>
                </tr>
              {{/each}}
            </table>
          </EmberTooltip>
        </div>
      {{/if}}
    </div>
  </template>
}
